module.exports = __webpack_public_path__ + "img/hzkh2.71523794.jpg";